import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";
import config from "../../Config/clientConfig.json"
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

export const SaleInvoice: React.FC<any> = React.memo((props) => {

  const [isProduct, setIsProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<any>([]);

  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const params = useParams();
  const id = params?.id;

  const { control, register, handleSubmit, setValue, getValues, watch } = useForm<any>();
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  const { fields, append, remove } = useFieldArray({
    name: "items",
    control,
  });

  useEffect(() => {
    calculateTotal(subtotal);
  }, [subtotal, watch("discount")]);

  const calculateTotal = (newSubtotal: number) => {

    const discount = parseFloat(watch("discount")) || 0;

    const newTotal = newSubtotal - discount;

    setTotal(newTotal);

    setValue("total", newTotal);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response: any = await callAPI("Vyapar/Product", Method.GET);
        console.log('product res', response);

        if (response) {
          setProducts(response || []);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await callAPI(
            `Vyapar/SaleInvoice/${id}`,
            Method.GET
          );

          if (response && response.data) {
            const saleInvoiceData = response.data;
            setValue("name", saleInvoiceData.name);
          }
        } catch (error) {
          console.error("Failed to fetch sale invoice data:", error);
        }
      };
      fetchData();
    }
  }, [id, setValue]);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProduct(event.target.checked);
  };

  const handleData = async (data: any) => {
    console.log("data are", data);

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("CustomerName", data.customer || "");
      formData.append("PhoneNumber", data.phoneNumber || "");
      formData.append("InvoiceDate", data.invoiceDate || "");
      formData.append("StateOfSupply", data.stateOfSupply || "");
      formData.append("Description", data.description || "");

      if (data.image) {
        formData.append("ImageUrl", data.image);
      }

      if (data.addDocument) {
        formData.append("DocumentUrl", data.addDocument[0]);
      }

      // Append Items using index
      if (data.items && data.items.length > 0) {
        data.items.forEach((item: any, index: number) => {

          formData.append(`Items[${index}].ProductId`, item.productId || "");
          formData.append(`Items[${index}].ItemCode`, item.itemCode || "");
          formData.append(`Items[${index}].HSNCode`, item.hsnCode || "");
          formData.append(`Items[${index}].Description`, item.description || "");
          formData.append(`Items[${index}].Quantity`, item.qty || "0");
          formData.append(`Items[${index}].PricePerUnit`, item.price || "0");
          formData.append(`Items[${index}].Discount`, item.discount || "0");
          formData.append(`Items[${index}].Amount`, item.amount || "0");
        });
      }

      let response;

      if (id) {
        response = await callAPI(
          `Vyapar/SaleInvoice/${id}`,
          Method.PUT,
          formData
        );
      } else {
        response = await callAPI(
          "Vyapar/SaleInvoice",
          Method.POST,
          formData
        );
      }

      console.log("handleData response===>", response);

      // if (response) {
      //   showMessage(
      //     response?.message,
      //     response.success ? "success" : "error"
      //   );

      //   if (response.success) {
      //     navigate("/sales/list");
      //   }
      // }

    } catch (error) {
      console.error("Failed to save invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/sales/list");
  };

  // const transFormData = (data: any) => {
  //   console.log('data is', data);

  //   return data.map((item: any) => ({
  //     label: item.name,
  //     value: item.id
  //   }));
  // };

  const handleProductChange = (index: number, event: any) => {

    const selectedProductId = event.target.value;

    const selectedProduct = products.find(
      (p: any) => p.id === selectedProductId
    );

    if (selectedProduct) {

      const price = selectedProduct.salePrice;
      const qty = 1;
      const amount = price * qty;

      setValue(`items.${index}.description`, selectedProduct.description);
      setValue(`items.${index}.price`, price);
      setValue(`items.${index}.itemCode`, selectedProduct.itemCode);
      setValue(`items.${index}.hsnCode`, selectedProduct.hsnSac);

      setValue(`items.${index}.qty`, qty);
      setValue(`items.${index}.amount`, amount);

      recalculateSubtotal();
    }
  };

  const handleQuantityChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    const qty = parseFloat(event.target.value) || 0;

    const price = parseFloat(getValues(`items.${index}.price`)) || 0;

    const amount = qty * price;

    setValue(`items.${index}.qty`, qty);
    setValue(`items.${index}.amount`, amount);

    recalculateSubtotal();
  };

  const handleUnitPriceChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    const price = parseFloat(event.target.value) || 0;

    const qty = parseFloat(getValues(`items.${index}.qty`)) || 0;

    const amount = qty * price;

    setValue(`items.${index}.price`, price);
    setValue(`items.${index}.amount`, amount);

    recalculateSubtotal();
  };

  const recalculateSubtotal = () => {

    const items = getValues("items") || [];

    const newSubtotal = items.reduce((sum: number, item: any) => {

      const qty = parseFloat(item.qty) || 0;
      const price = parseFloat(item.price) || 0;

      return sum + qty * price;

    }, 0);

    setSubtotal(newSubtotal);

    calculateTotal(newSubtotal);
  };

  return (
    <form>
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item>
                  <Typography fontWeight="bold" variant="h6">
                    Sale Invoice
                  </Typography>
                </Grid>

                {/* <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: !isProduct ? "primary.main" : "text.secondary",
                      fontWeight: !isProduct ? "bold" : "normal",
                    }}
                  >
                    Credit
                  </Typography>
                </Grid>

                <Grid item>
                  <Switch
                    checked={isProduct}
                    onChange={handleToggle}
                    color="primary"
                    size="small"
                  />
                </Grid>

                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: isProduct ? "primary.main" : "text.secondary",
                      fontWeight: isProduct ? "bold" : "normal",
                    }}
                  >
                    Cash
                  </Typography>
                </Grid> */}
              </Grid>
            </Grid>

            {/* Right side: Close Icon */}
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12} sm={6}>
              <WSPhone
                label={"Phone No"}
                id={"phoneNumber"}
                name={"phoneNumber"}
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {!isProduct ? (
                // Credit: Show Customer
                <WSTextField
                  label={"Customer"}
                  {...register("customer")}
                  id="customer"
                  name="customer"
                  control={control}
                  rules={{ required: true }}
                />
              ) : (
                // Cash: Show Billing Name + Address
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <WSTextField
                      label={"Billing Name"}
                      {...register("billingName")}
                      id="billingName"
                      name="billingName"
                      control={control}
                      rules={{ required: true }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <WSTextAreaField
                      label={"Address"}
                      {...register("address")}
                      id="address"
                      name="address"
                      control={control}
                      rows={3}
                      rules={{ required: true }}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Invoice No"}
                {...register("invoiceNo")}
                id="invoiceNo"
                name="invoiceNo"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="invoiceDate"
                name="invoiceDate"
                label={"Invoice Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="stateOfSupply"
                {...register("stateOfSupply")}
                name="stateOfSupply"
                label="State Of Supply"
                options={config.stateConfig.staticOptionData}
                // defaultValue={config.stateConfig.staticOptionData[11].value}
              />
            </Grid>
            {fields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                <Grid item xs={12} sm={1}>
                  {/* <WSTextField
                    label="Item"
                    {...register(`items.${index}.item`)}
                    id={`item-${index}`}
                    control={control}
                  /> */}

                  <WSSelectField
                    label="Product *"
                    rules={{ required: true }}
                    {...register(`items.${index}.productId`)}
                    id={`selectProduct-${index}`}
                    control={control}
                    options={products.map((product: any) => ({
                      label: product.name,
                      value: product.id
                    }))}
                    inlineSearch
                    onChange={(event) => handleProductChange(index, event)}
                  />

                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Item Code"
                    {...register(`items.${index}.itemCode`)}
                    id={`itemCode-${index}`}
                    control={control}
                  />

                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="HSN Code"
                    {...register(`items.${index}.hsnCode`)}
                    id={`hsnCode-${index}`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="Description"
                    id={`description-${index}`}
                    {...register(`items.${index}.description`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="QTY"
                    id={`qty-${index}`}
                    {...register(`items.${index}.qty`, {
                      onChange: (event) => handleQuantityChange(index, event)
                    })}
                    type={TextType.AllowOnlyNumber}
                    control={control}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={1}>
                  <WSSelectField
                    label="Unit"
                    rules={{ required: true }}
                    {...register(`items.${index}.unit`)}
                    id={`unit-${index}`}
                    control={control}
                    options={config.unitconfig.staticOptionData}
                  />
                </Grid> */}
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Price/Unit"
                    id={`price-${index}`}
                    {...register(`items.${index}.price`, {
                      onChange: (event) => handleUnitPriceChange(index, event)
                    })}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Discount"
                    id={`discount-${index}`}
                    {...register(`items.${index}.discount`, {})}
                    control={control}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Tax"
                    id={`tax-${index}`}
                    {...register(`items.${index}.tax`, {})}
                    control={control}
                  />
                </Grid> */}
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Amount"
                    id={`amount-${index}`}
                    {...register(`items.${index}.amount`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => {
                      remove(index);

                      setTimeout(() => {
                        recalculateSubtotal();
                      }, 10);
                    }}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ Add"
                size="small"
                onClick={() =>
                  append({
                    productId: "",
                    qty: "",
                    unit: "",
                    price: "",
                    amount: "",
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextAreaField
                label={"Description"}
                id={"description"}
                name={"description"}
                control={control}
                rules={{ required: false }}
                rows={3}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Total"}
                {...register("total")}
                id="total"
                name="total"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSImageUpload
                control={control}
                id="image"
                name="image"
                label="Add image"
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSFileUpload
                name="addDocument"
                label="Add Document"
                control={control}
                rules={{ required: false }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                //  defaultValue={defaultImg}
                id={"addDocument"}
                image={true}
                align="Start"
                isToolTipImg={false}
                multiple={true}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
        <Grid item>
          <WSButton
            id="share"
            label="Share"
            size="medium"
            variant="outlined"
            color="primary"
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "rgba(126, 176, 246, 1)",
              backgroundColor: "#FFFFFF",
            }}
          />
        </Grid>

        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save"
            size="medium"
            variant="outlined"
            loading={loading}
            color="primary"
            onClick={handleSubmit(handleData)}
            sx={{
              borderRadius: 2,
              width: "6rem",
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "#FFFFFF",
              backgroundColor: "rgba(126, 176, 246, 1)",
              "&:hover": {
                backgroundColor: "rgba(126, 176, 246, 1)",
              },
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
});
